import AuthActions from './auth/actions';
import { store } from './store';

export default () =>
  new Promise(async (resolve, reject) => {
    try {
      const auth = window.localStorage.getItem('payload');

      store.dispatch({
        type: AuthActions.CHECK_AUTHORIZATION,
        value: auth ? JSON.parse(auth) : {},
      });

      resolve(auth);
    } catch (error) {
      store.dispatch({
        type: AuthActions.CHECK_AUTHORIZATION,
        value: {},
      });
      resolve({});
    }
  });
